// Blend a 3/6-digit hex with an alpha. Returns the input unchanged if it isn't
// parseable hex (e.g. a classDef color that's already `rgb(...)` or a keyword).
export function hexToRgba(hex: string, alpha: number): string {
  const normalized = hex.replace('#', '');
  const expanded =
    normalized.length === 3
      ? normalized
          .split('')
          .map((char) => char + char)
          .join('')
      : normalized;
  const red = parseInt(expanded.slice(0, 2), 16);
  const green = parseInt(expanded.slice(2, 4), 16);
  const blue = parseInt(expanded.slice(4, 6), 16);
  if (Number.isNaN(red) || Number.isNaN(green) || Number.isNaN(blue)) {
    return hex;
  }
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

const VALUE_LOCALE = 'en-US';

export function formatTreemapValue(value: number): string {
  return Number.isInteger(value)
    ? value.toLocaleString(VALUE_LOCALE)
    : value.toLocaleString(VALUE_LOCALE, { maximumFractionDigits: 2 });
}
